const items = {
  items: [
    {
      id: "navigation",
      title: "Navigation",
      type: "group",
      icon: "icon-navigation",
      children: [
        {
          id: "dashboard",
          title: "Dashboard",
          type: "item",
          url: "dashboard",
          icon: "fa-solid fa-display",
        },
        {
          id: "noc",
          title: "Overwatch",
          type: "item",
          url: "overwatch",
          icon: "fa-solid fa-eye",
          permission: "overwatch"
        },
        {
          id: "devices",
          title: "Device Dashboard",
          type: "item",
          url: "devices",
          icon: "fa-solid fa-server",
          badge: {
            title: "deviceCount",
            type: "label-info",
          },
          permission: "devices"
        },
        {
          id: "import",
          title: "Device Import",
          type: "item",
          url: "devicesimport",
          icon: "fa-solid fa-floppy-disk",
          badge: {
            title: "pendingCount",
            type: "label-info",
          },
          permission: "write_devices"
        },
        {
          id: "network",
          title: "Visual Network Explorer",
          type: "item",
          url: "vne",
          icon: "fa-solid fa-compass",
          permission: "vne"
        },
        {
          id: "logs",
          title: "Log Scrutineer",
          type: "item",
          url: "logs",
          icon: "fa-solid fa-magnifying-glass",
          permission: "logs"
        },
        {
          id: "alertsub",
          title: "Alerting",
          icon: "fa-solid fa-triangle-exclamation",
          badge: {
            title: "alertCount",
            type: "label-info",
          },
          type: "collapse",
          permission: "alerts",
          children: [
            {
              id: "alerts",
              title: "Alert Manager",
              type: "item",
              url: "alerts",
              permission: "alerts",
              icon: "fa-solid fa-list-check"
            },
            {
              id: "alerthis",
              title: "Alert History",
              type: "item",
              url: "alerthistory",
              permission: "alerts",
              icon: "fa-solid fa-history"
            },
            {
              id: "alerttem",
              title: "Template Editor",
              type: "item",
              url: "alerttemplates",
              permission: "alerts",
              icon: "fa-solid fa-palette"
            },
          ]
        },

        {
          id: "reports",
          title: "Reports",
          type: "item",
          icon: "fa-solid fa-chart-line",
          url: "reports",
          permission: "reports"
        },
        {
          id: "webTracker",
          title: "URL Trackers",
          type: "item",
          icon: "fa-solid fa-link",
          url: "urls",
          permission: "urls"
        },
        {
          id: "tools",
          title: "Network Tools",
          type: "collapse",
          icon: "fa-solid fa-screwdriver-wrench",
          permission: "tools",
          children: [
            {
              id: "Ping",
              title: "Ping",
              type: "item",
              url: "ping",
              icon: "fa-solid fa-table-tennis-paddle-ball "
            },
            {
              id: "Traceroute",
              title: "Traceroute",
              type: "item",
              url: "traceroute",
              icon: "fa-solid fa-route "
            },
            {
              id: "MTR",
              title: "Matt's Traceroute",
              type: "item",
              url: "mtr",
              icon: "fa-solid fa-map "
            },
            {
              id: "SnmpWalk",
              title: "SNMP Explorer",
              type: "item",
              url: "snmpwalk",
              icon: "fa-solid fa-table "
            },
            {
              id: "Portscan",
              title: "Portscan",
              type: "item",
              url: "portscan",
              icon: "fa-solid fa-microscope "

            },
            {
              id: "Speedtest",
              title: "Network Speedtest",
              type: "item",
              url: "speedtest",
              icon: "fa-solid fa-gauge-high "
            },
          ],
        },
        {
          id: "manage",
          title: "System",
          type: "collapse",
          icon: "fa-solid fa-gear",
          permission: "system",
          children: [
            {
              id: "settings",
              title: "System Settings",
              type: "item",
              url: 'settings',
              icon: "fa-solid fa-sliders"
            },
            {
              id: "Users",
              title: "Users and Permissions",
              type: "item",
              url: "users",
              permission: "users",
              icon: "fa-solid fa-users"
            },
          ],
        },
      ],
    },
  ],

};
export default items;